import { Injectable } from "@angular/core";
import { AuthenticationService } from '../services/authentication.service';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from "@angular/common/http";
import { Observable } from "rxjs";
import { switchMap, take, filter } from 'rxjs/operators';
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class HttpTokenInterceptor implements HttpInterceptor {
  URLAttemptedToken: any;
  NormalLoginoken: any;
  constructor(private authService: AuthenticationService,public router: Router) {}
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
   // add JWT auth header if a user is logged in for API requests
   // add auth header with jwt if user is logged in and request is to the api url
   if (request.url.indexOf('refresh') !== -1) {
    return next.handle(request);
}
const accessExpired = this.authService.isTokenExpired();

if (accessExpired) {
  return this.authService.refreshToken().pipe(
          switchMap((authResponse) => {
             return next.handle(this.injectToken(request));
          }),
      );
        }
else if (!accessExpired) {
  return next.handle(this.injectToken(request));
}
  //  if(user){
  //   if (request.url.includes('/refresh')) {
  //     //user.accessToken=""
  //     request = request.clone({
      
  //   });
  //   }else{
  //     const isLoggedIn = user && user.accessToken;
  //     if (isLoggedIn) {
  //           request = request.clone({
  //               setHeaders: { Authorization: `Bearer ${user.accessToken}` }
  //           });
  //       }
  //   }
  
  //  }
  //  return next.handle(request);
  }

  // injectToken(request: HttpRequest<any>) {
  //   //debugger
  //  this.URLAttemptedToken = sessionStorage.getItem('loginURLAttempted');
  //  this.NormalLoginoken = sessionStorage.getItem('loginAttempted');
  //   // if(this.authService.userValue){
  //   if(this.NormalLoginoken == "true"){
  //     const user = this.authService.userValue;
  //     const isLoggedIn = user && user.accessToken;
  //       if (isLoggedIn) {
  //        const token = user.accessToken;
  //      return request.clone({
  //          setHeaders: {
  //              Authorization: `Bearer ${token}`
  //          }
  //      });
  //    }else{
  //      return request.clone({
  //       });
  //    }
  //   }else if(this.URLAttemptedToken == "true"){
  //        const token = JSON.parse(localStorage.getItem("currentToken")as string)
  //        const isLoggedIn = token 
  //        if (isLoggedIn) {
  //          return request.clone({
  //              setHeaders: {
  //                  Authorization: `Bearer ${token}`
  //              }
  //          });
  //        }
  //  }
  //      // else{
  //      //   const token = JSON.parse(localStorage.getItem("currentToken")as string)
  //      //   const isLoggedIn = token 
  //      //   if (isLoggedIn) {
  //      //     return request.clone({
  //      //         setHeaders: {
  //      //             Authorization: `Bearer ${token}`
  //      //         }
  //      //     });
  //      //   }
  //      // }
  //  // }
  //   }
  // injectToken(request: HttpRequest<any>) {
  //   //debugger;
  //   this.URLAttemptedToken = sessionStorage.getItem('loginURLAttempted');
  //   this.NormalLoginoken = sessionStorage.getItem('loginAttempted');
  
  //   if (this.NormalLoginoken === "true") {
  //     const user = this.authService.userValue;
  //     const isLoggedIn = user && user.accessToken;
  //     if (isLoggedIn) {
  //       const token = user.accessToken;
  //       return request.clone({
  //         setHeaders: {
  //           Authorization: `Bearer ${token}`
  //         }
  //       });
  //     }
  //   } 
  //   else if (this.URLAttemptedToken === "true") {
  //     const token = JSON.parse(localStorage.getItem("currentToken") as string);
  //     const isLoggedIn = token;
  //     if (isLoggedIn) {
  //       return request.clone({
  //         setHeaders: {
  //           Authorization: `Bearer ${token}`
  //         }
  //       });
  //     }
  //   }
  // else{
  //   // fallback if none are true
  //   return request.clone();
  // }
  // }
  injectToken(request: HttpRequest<any>) {
    //debugger
    let attempts = 0;
    const maxAttempts = 5;
  
    while (attempts < maxAttempts) {
      this.URLAttemptedToken = sessionStorage.getItem('loginURLAttempted');
      this.NormalLoginoken = sessionStorage.getItem('loginAttempted');
  
      if (this.NormalLoginoken === "true") {
        const user = this.authService.userValue;
        if (user && user.accessToken) {
          const token = user.accessToken;
          return request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
        }
      } 
      else if (this.URLAttemptedToken === "true") {
        const token = JSON.parse(localStorage.getItem("currentToken") as string);
        if (token) {
          return request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
        }
      }
  
      attempts++;
    }
  
    // If no valid token or flags found, redirect to 404 page
    // const token = JSON.parse(localStorage.getItem("currentToken") as string);
    // if(token == null || token == '' || token == undefined)
    // this.router.navigate(['/page-not-found']);
  
    // Optionally return the original request (though it won't be used after navigation)
    return request.clone();
  }
  }
